import type { track as TrackType } from "pro-features/components/WithTrack/src/context";
import type { CreatingSteps } from "app/pages/activation/components/RankWidget/types";
import { allTrackers } from "app/services/track/track";

export type RankTrackingSchema = {
    trackClickCreateCampaignButton: (topicsCount: number) => void;
    trackCancelCreation: (stage: CreatingSteps) => void;
    trackConfirmInitialStep: () => void;
    trackChangeCountry: (country: string) => void;
    trackChangeCompetitors: (competitorsCunt: number) => void;
    trackChangeSource: (source: string) => void;
    trackConfirmCreation: () => void;
    trackCreationSuccess: () => void;
    trackClickLearnMore: () => void;
    trackClickViewCampaign: () => void;
    trackClickOnFilter: (filterName: string, keywordsCount: number) => void;
};

const createRankTracking = (track: TrackType): RankTrackingSchema => ({
    trackClickCreateCampaignButton(topicsCount) {
        track("Button", "click", `start rank tracker setup/create campaign/${topicsCount} topics`);
    },
    trackCancelCreation(stage) {
        track("Button", "click", `cancel rank tracker setup/rank tracker wizard/stage ${stage + 1}`);
    },
    trackConfirmInitialStep() {
        track("Button", "click", "finish rank tracker step 1/rank tracker wizard");
    },
    trackChangeCountry(country) {
        track("Drop Down", "click", `select rank tracker country/rank tracker wizard/${country}`);
    },
    trackChangeCompetitors(competitorsCount) {
        track("Drop Down", "click", `change rank tracker competitors/rank tracker wizard/${competitorsCount}`);
    },
    trackChangeSource(source) {
        track("Drop Down", "click", `change rank tracker traffic type/rank tracker wizard/${source}`);
    },
    trackConfirmCreation() {
        track("Button", "click", "finish rank tracker setup/rank tracker wizard");
    },
    trackCreationSuccess() {
        track("Notification", "success", "rank tracker campaign created/rank tracker wizard");
    },
    trackClickLearnMore() {
        track("Link", "click", "learn more/rank tracker wizard");
    },
    trackClickViewCampaign() {
        track("Button", "click", "view rank tracker/rank tracker wizard");
    },
    trackClickOnFilter(filterName, keywordsCount) {
        track("Button", "click", `rank tracker quick filter/${filterName}/${keywordsCount} keywords`);
    },
});

export default createRankTracking(allTrackers.dispatchTrackEvent.bind(allTrackers));
